module.exports = __webpack_public_path__ + "img/header.6ceadc9.webp";